import React from 'react';
import FormCard from '../components/common/FormCard';
import {
  InfoCircleIcon,
  LightningIcon,
  DocumentIcon,
  VideoTutorialIcon,
  HeartIcon,
  MailIcon,
  ExternalLinkIcon,
  LockIcon,
  linkTextIcon
} from '../components/common/SvgIcon';

const HelpSupport = () => {
  const supportSections = [
    {
      icon: <LockIcon />,
      title: "Documentation",
      description: "Browse our comprehensive documentation to learn how to use every feature.",
      linkText: "Read Docs",
      linkUrl: "https://wpwax.com/docs/legal-pages/"
    },
    {
      icon: <VideoTutorialIcon />,
      title: "Video Tutorials",
      description: "Watch step-by-step video guides to get started quickly.",
      linkText: "Watch Videos",
      linkUrl: "https://wpwax.com/product/legal-pages-pro/"
    },
    {
      icon: <DocumentIcon />,
      title: "FAQs",
      description: "Find answers to commonly asked questions.",
      linkText: "View FAQs",
      linkUrl: "https://wpwax.com/product/legal-pages-pro/"
    },
    {
      icon: <LightningIcon />,
      title: "Feature Requests",
      description: "Suggest new features or vote on existing requests.",
      linkText: "Submit Request",
      linkUrl: "https://wpwax.com/dashboard/?tab=support"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b !from-gray-50 !to-white py-10 px-4 sm:px-6 lg:px-8">
      <div className="!max-w-[890px] mx-auto">
        
        {/* Header */}
        <div className="text-center mb-10 sm:mb-12">
          <div className="inline-flex items-center justify-center !w-[80px] !h-[80px] rounded-3xl mb-6 overflow-hidden">
            <InfoCircleIcon size={80} />
          </div>

          <div className="flex flex-col items-center text-center px-4 max-w-[576px] mx-auto">
            <h1 className="font-inter !font-bold text-[28px] sm:!text-[32px] !leading-[36px]">
              Need Help?
            </h1>
            <p className="font-inter !font-normal text-[15px] sm:!text-[16px] !leading-[26px] sm:!leading-[28px] text-gray-600 mt-1">
              Get special care from our dedicated support team. We're here to help you succeed.
            </p>
          </div>
        </div>

        {/* Support Box */}
        <div className="mb-8 !bg-[#7C3BED1A] h-auto sm:!h-[360px] !rounded-[20px] flex flex-col items-center justify-center px-4 py-10">

          <div className="text-center">
            <div className="inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 mb-4">
              <HeartIcon />
            </div>

            <div className="flex flex-col items-center text-center px-2 sm:px-4 max-w-[500px] mx-auto">
              <h2 className="font-inter !font-semibold text-[17px] sm:!text-[18px] !leading-[28px] text-gray-900">
                Contact Support
              </h2>

              <p className="font-inter !font-normal text-[15px] sm:!text-[16px] !leading-[26px] sm:!leading-[28px] text-gray-600 mt-1">
                Our support team is available Monday to Friday, 9am to 5pm EST.
                We typically respond within 24 hours.
              </p>
            </div>

            <a
              href="https://wpwax.com/dashboard/?tab=support"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-[14px] !w-[200px] sm:!w-[223px] !h-[52px] sm:!h-[56px] 
                px-[28px] py-[12px] sm:!px-[32px] sm:!py-[14px] 
                !bg-[#7C3BED] !text-white font-inter !font-semibold
                text-[14px] sm:!text-[16px] !leading-[26px] sm:!leading-[28px] 
                !rounded-[12px] opacity-100 mt-4 shadow-[0px_4px_14px_-2px_#7C3BED40]"
            >
              <MailIcon className="w-5 h-5" />
              Get Support
              <ExternalLinkIcon className="w-4 h-4" />
            </a>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          {supportSections.map((section, index) => (
            <FormCard key={index} className="hover:shadow-xl hover:-translate-y-1 !transition">
              <div className="flex flex-col h-full">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-purple-100 rounded-xl mb-4">
                  {section.icon}
                </div>
                <h3 className="text-[18px] sm:!text-xl !font-bold text-gray-900 mb-2">
                  {section.title}
                </h3>
                <p className="text-gray-600 mb-6 flex-grow text-[14px] sm:text-[15px]">
                  {section.description}
                </p>
                <a
                  href={section.linkUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 !text-purple-600 hover:!text-purple-700 font-semibold transition-colors text-[15px] focus:!outline-none focus:!shadow-none"
                >
                  {section.linkText}
                  {linkTextIcon}
                </a>
              </div>
            </FormCard>
          ))}
        </div>

        {/* Footer */}
        <div className="text-center pb-6">
          <p className="text-gray-600 text-[15px] sm:text-[16px]">
            You can also reach us directly at{" "}
            <a href="mailto:support@wpwax.com" className="!text-purple-600 hover:!text-purple-700 !font-semibold">
              support@wpwax.com
            </a>
          </p>
        </div>

      </div>
    </div>
  );
};

export default HelpSupport;
